import { render, staticRenderFns } from "./WcFormsValidFeedback.vue?vue&type=template&id=35801d04&lang=pug&"
import script from "./WcFormsValidFeedback.vue?vue&type=script&lang=js&"
export * from "./WcFormsValidFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports